import { EventEmitter } from 'eventemitter3';

type Events = 'logout' | 'tokenRefreshed' | 'logoutReceivedFromTab';

const eventEmitter = new EventEmitter<Events>();

export { eventEmitter };
